import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
  createSupplier,
  updateSupplier,
  selectSuppliers,
} from './suppliersSlice';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import {makeStyles, useTheme, withStyles} from '@material-ui/core/styles';

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: '#D86D7E',
    color: '#FFF',
    '&:hover': {
      opacity: 0.9,
      backgroundColor: '#D86D7E',
    },
    width: '100%',
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  outer: {display: 'flex', flexFlow: 'column'},
  addIcon: {
    marginRight: 8,
    color: '#fff',
  },
  title: {
    color: '#fff',
    padding: 16,
    backgroundColor: ' #42494E',
    textAlign: 'center',
    fontSize: 24,
    fontWeight: 'bold',
  },
  textItem: {
    marginBottom: 16,
  },
}));

export default function Supplier(props) {
  const {edit, product} = props;
  let jwtToken = localStorage.getItem('coreToken');
  const dispatch = useDispatch();
  const [editSupplier, setEditSupplier] = useState(false);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [mobile, setMobile] = useState('');
  const [fax, setFax] = useState('');
  const [description, setDescription] = useState('');
  const [xeroID, setXeroID] = useState('');
  //street
  const [po, setPO] = useState('');
  const [streetNumber, setStreetNumber] = useState('');
  const [streetName, setStreetName] = useState('');
  const [postCode, setPostCode] = useState('');
  const [subarb, setSubarb] = useState('');

  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [country, setCountry] = useState('');

  //postal
  const [poPostal, setPOPostal] = useState('');
  const [streetNumberPostal, setStreetNumberPostal] = useState('');
  const [streetNamePostal, setStreetNamePostal] = useState('');
  const [postCodePostal, setPostCodePostal] = useState('');
  const [subarbPostal, setSubarbPostal] = useState('');

  const [cityPostal, setCityPostal] = useState('');
  const [statePostal, setStatePostal] = useState('');
  const [countryPostal, setCountryPostal] = useState('');

  const [statusIDs, setStatusIDs] = useState([]);
  const [statusList, setStatusList] = useState([
    {id: 1, value: 'active'},
    {id: 2, value: 'inactive'},
    {id: 3, value: 'deleted'},
    {id: 4, value: 'unavailable'},
  ]);
  const [productStatus, setProductStatus] = useState('');
  const [addressMatch, setAddressMatch] = useState(false);
  const {editing, supplier} = useSelector(selectSuppliers);
  useEffect(() => {
    if (editing && supplier !== {}) {
      setEditSupplier(true);
      setName(supplier.name);
      setEmail(supplier.emailAddress);
      setPhone(supplier.phone_number);
      setMobile(supplier.mobileNumber);
      setDescription(supplier.description);
      setXeroID(supplier.xeroID);
      //street
      setPO(supplier.streetAddress.poBox);
      setStreetNumber(supplier.streetAddress.streetNumber);
      setStreetName(supplier.streetAddress.streetName);
      setPostCode(supplier.streetAddress.postCode);
      setSubarb(supplier.streetAddress.suburb);

      setCity(supplier.streetAddress.city);
      setState(supplier.streetAddress.state);
      setCountry(supplier.streetAddress.country);
      //postal
      setPOPostal(supplier.postalAddress.poBox);
      setStreetNumberPostal(supplier.postalAddress.streetNumber);
      setStreetNamePostal(supplier.postalAddress.streetName);
      setPostCodePostal(supplier.postalAddress.postCode);
      setSubarbPostal(supplier.postalAddress.suburb);
      setCityPostal(supplier.postalAddress.city);
      setStatePostal(supplier.postalAddress.state);
      setCountryPostal(supplier.postalAddress.country);

      setStatusIDs(supplier.statusID);
      setProductStatus(statusList[supplier.statusID - 1].value);
      setOpen(true);
    }
  }, [supplier]);

  const handleClickOpen = () => {
    setEditSupplier(false);
    setName('');
    setEmail('');
    setPhone('');
    setMobile('');
    setDescription('');
    setXeroID('');
    //street
    setPO('');
    setStreetNumber('');
    setStreetName('');
    setPostCode('');
    setSubarb('');

    setCity('');
    setState('');
    setCountry('');
    //postal
    setPOPostal('');
    setStreetNumberPostal('');
    setStreetNamePostal('');
    setPostCodePostal('');
    setSubarbPostal('');

    setCityPostal('');
    setStatePostal('');
    setCountryPostal('');

    setStatusIDs([]);
    setProductStatus([]);
    setOpen(true);
  };

  const handleClose = () => {
    setEditSupplier(false);
    setName('');
    setEmail('');
    setPhone('');
    setMobile('');
    setDescription('');
    //street
    setPO('');
    setStreetNumber('');
    setStreetName('');
    setPostCode('');
    setSubarb('');

    setCity('');
    setState('');
    setCountry('');
    //postal
    setPOPostal('');
    setStreetNumberPostal('');
    setStreetNamePostal('');
    setPostCodePostal('');
    setSubarbPostal('');

    setCityPostal('');
    setStatePostal('');
    setCountryPostal('');

    setStatusIDs([]);
    setProductStatus([]);
    setOpen(false);
  };

  const handleStatusChange = (event) => {
    let selectedStatus = statusList.filter(
      (status) => status.value === event.target.value
    );
    selectedStatus[0] && setStatusIDs(selectedStatus[0].id);

    setProductStatus(event.target.value);
  };

  const handleAddressToggle = () => {
    setAddressMatch(!addressMatch);
  };

  const handleCreate = () => {
    let supplierData = {
      statusID: statusIDs,
      name: name,
      description: description,
      emailAddress: email,
      phone_number: phone,
      mobileNumber: mobile,
      xeroID: xeroID,
      streetAddress: {
        poBox: po,
        streetNumber: streetNumber,
        streetName: streetName,
        suburb: subarb,
        postCode: postCode,
        city: city,
        state: state,
        country: country,
      },
      postalAddress: {
        poBox: addressMatch ? po : poPostal,
        streetNumber: addressMatch ? streetNumber : streetNumberPostal,
        streetName: addressMatch ? streetName : streetNamePostal,
        suburb: addressMatch ? subarb : subarbPostal,
        postCode: addressMatch ? postCode : postCodePostal,
        city: addressMatch ? city : cityPostal,
        state: addressMatch ? state : statePostal,
        country: addressMatch ? country : countryPostal,
      },
    };

    dispatch(
      createSupplier({
        supplier: supplierData,
        token: jwtToken,
      })
    );
  };

  const handleUpdate = () => {
    let supplierData = {
      statusID: statusIDs,
      name: name,
      description: description,
      emailAddress: email,
      phone_number: phone,
      mobileNumber: mobile,
      xeroID: xeroID,
      streetAddress: {
        poBox: po,
        streetNumber: streetNumber,
        streetName: streetName,
        suburb: subarb,
        postCode: postCode,
        city: city,
        state: state,
        country: country,
      },
      postalAddress: {
        poBox: addressMatch ? po : poPostal,
        streetNumber: addressMatch ? streetNumber : streetNumberPostal,
        streetName: addressMatch ? streetName : streetNamePostal,
        suburb: addressMatch ? subarb : subarbPostal,
        postCode: addressMatch ? postCode : postCodePostal,
        city: addressMatch ? city : cityPostal,
        state: addressMatch ? state : statePostal,
        country: addressMatch ? country : countryPostal,
      },
    };

    dispatch(
      updateSupplier({
        updatedSupplier: supplierData,
        token: jwtToken,
        id: supplier.id,
      })
    );
  };

  const classes = useStyles();
  const theme = useTheme();
  // const [open, setOpen] = React.useState(false);

  return (
    <div>
      <IconButton
        aria-label="add new"
        style={product ? {marginLeft: 0} : {marginLeft: 0}}
      >
        <AddCircleIcon
          style={product ? {marginRight: 0} : {marginRight: 8, color: '#fff'}}
          onClick={handleClickOpen}
        />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="md"
        scroll="paper"
      >
        <DialogTitle
          disableTypography
          className={classes.title}
          id="form-dialog-title"
        >
          {editSupplier ? 'Edit Supplier' : 'Add Supplier'}
        </DialogTitle>
        <DialogContent style={{maxHeight: 500}} dividers={true}>
          <DialogContentText style={{paddingTop: 8, textAlign: 'center'}}>
            {editSupplier
              ? 'Update Supplier Details'
              : 'Enter Supplier Details'}
          </DialogContentText>
          <Grid container spacing={2} direction="row">
            <Grid item sm>
              <Grid container direction="column">
                <Grid item sm>
                  <TextField
                    defaultValue={name}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Name"
                    type="name"
                    required
                    fullWidth
                    onChange={(e) => setName(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={description}
                    className={classes.textItem}
                    variant="outlined"
                    multiline
                    rows={2}
                    margin="dense"
                    id="description"
                    label="Description"
                    type="description"
                    fullWidth
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Grid>

                <Grid item sm>
                  <TextField
                    defaultValue={email}
                    className={classes.textItem}
                    required
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="email"
                    label="Email"
                    type="email"
                    fullWidth
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <Grid container direction="column">
                <Grid item sm>
                  <TextField
                    defaultValue={phone}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="phone-number"
                    label="Phone Number"
                    type="tel"
                    fullWidth
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={mobile}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="mobile"
                    label="Mobile"
                    type="tel"
                    fullWidth
                    onChange={(e) => setMobile(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={xeroID}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="xeroID"
                    label="Xero Contact ID"
                    type="tel"
                    fullWidth
                    onChange={(e) => setXeroID(e.target.value)}
                  />
                </Grid>

                <Grid item sm style={{paddingTop: 8}}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    style={{
                      width: '100%',
                    }}
                  >
                    <InputLabel htmlFor="outlined-status-simple" margin="dense">
                      Supplier Status
                    </InputLabel>
                    <Select
                      value={productStatus}
                      onChange={(e) => handleStatusChange(e)}
                      margin="dense"
                      label="Supplier Status"
                      required
                      inputProps={{
                        name: 'status',
                        id: 'outlined-status-simple',
                      }}
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                      <MenuItem value="unavailable">Unavailable</MenuItem>
                      <MenuItem value="deleted">Deleted</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Divider />
          <Typography
            variant="body1"
            style={{textAlign: 'center', padding: 8, paddingTop: 16}}
          >
            Street Address
          </Typography>
          <Grid container direction="column">
            <Grid item sm>
              <Grid container direction="row" spacing={2}>
                <Grid item sm>
                  <TextField
                    defaultValue={po}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="street-po"
                    label="PO Box"
                    type="text"
                    fullWidth
                    onChange={(e) => setPO(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={streetNumber}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="street-number-street"
                    label="Street Number"
                    type="text"
                    fullWidth
                    onChange={(e) => setStreetNumber(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <TextField
                defaultValue={streetName}
                className={classes.textItem}
                variant="outlined"
                autoFocus
                margin="dense"
                id="street-number-street"
                label="Street Name"
                type="text"
                fullWidth
                onChange={(e) => setStreetName(e.target.value)}
              />
            </Grid>
            <Grid item sm>
              <Grid container direction="row" spacing={2}>
                <Grid item sm>
                  <TextField
                    defaultValue={subarb}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="subarb-street"
                    label="Subarb"
                    type="text"
                    fullWidth
                    onChange={(e) => setSubarb(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={postCode}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="post-code-street"
                    label="Post Code"
                    type="text"
                    fullWidth
                    onChange={(e) => setPostCode(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <Grid container direction="row" spacing={2}>
                <Grid item sm>
                  <TextField
                    defaultValue={city}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="city-street"
                    label="City"
                    type="text"
                    fullWidth
                    onChange={(e) => setCity(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={state}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="state-street"
                    label="State"
                    type="text"
                    fullWidth
                    onChange={(e) => setState(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <TextField
                defaultValue={country}
                className={classes.textItem}
                variant="outlined"
                autoFocus
                margin="dense"
                id="country-street"
                label="Country"
                type="text"
                fullWidth
                onChange={(e) => setCountry(e.target.value)}
              />
            </Grid>
          </Grid>
          <Divider />
          <Typography
            variant="body1"
            style={{textAlign: 'center', padding: 8, paddingTop: 16}}
          >
            Postal Address
          </Typography>
          <Grid container direction="column">
            <Grid item sm>
              <Grid container direction="row" spacing={2}>
                <Grid item sm>
                  <TextField
                    defaultValue={poPostal}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="street-po"
                    label="PO Box"
                    type="text"
                    fullWidth
                    onChange={(e) => setPOPostal(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={streetNumberPostal}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="street-number-street"
                    label="Street Number"
                    type="text"
                    fullWidth
                    onChange={(e) => setStreetNumberPostal(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <TextField
                defaultValue={streetNamePostal}
                className={classes.textItem}
                variant="outlined"
                autoFocus
                margin="dense"
                id="street-number-street"
                label="Street Name"
                type="text"
                fullWidth
                onChange={(e) => setStreetNamePostal(e.target.value)}
              />
            </Grid>
            <Grid item sm>
              <Grid container direction="row" spacing={2}>
                <Grid item sm>
                  <TextField
                    defaultValue={subarbPostal}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="subarb-street"
                    label="Suburb"
                    type="text"
                    fullWidth
                    onChange={(e) => setSubarbPostal(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={postCodePostal}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="post-code-street"
                    label="Post Code"
                    type="text"
                    fullWidth
                    onChange={(e) => setPostCodePostal(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <Grid container direction="row" spacing={2}>
                <Grid item sm>
                  <TextField
                    defaultValue={cityPostal}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="city-street"
                    label="City"
                    type="text"
                    fullWidth
                    onChange={(e) => setCityPostal(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={statePostal}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="state-street"
                    label="State"
                    type="text"
                    fullWidth
                    onChange={(e) => setStatePostal(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <TextField
                defaultValue={countryPostal}
                className={classes.textItem}
                variant="outlined"
                autoFocus
                margin="dense"
                id="country-street"
                label="Country"
                type="text"
                fullWidth
                onChange={(e) => setCountryPostal(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{paddingLeft: 24, paddingRight: 24, paddingBottom: 16}}
        >
          <Grid container spacing={2} direction="row">
            <Grid item sm>
              <ColorButton onClick={handleClose} color="primary">
                Cancel
              </ColorButton>
            </Grid>
            <Grid item sm>
              <ColorButton
                onClick={editSupplier ? handleUpdate : handleCreate}
                color="secondary"
              >
                {editSupplier ? 'Update Supplier' : 'Create Supplier'}
              </ColorButton>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}

// {
//   "statusID": 2,
//   "name": "1",
//   "description": "2",
//   "emailAddress": "3",
//   "phone_number": "4",
//   "streetAddress": {
//     "poBox": "6",
//     "streetNumber": "7",
//     "streetName": "8",
//     "suburb": "9",
//     "postCode": "10",
//     "city": "11",
//     "state": "12",
//     "country": "13"
//   },
//   "postalAddress": {
//     "poBox": "14",
//     "streetNumber": "15",
//     "streetName": "16",
//     "suburb": "17",
//     "postCode": "18",
//     "city": "19",
//     "state": "20",
//     "country": "21"
//   }
// }
